import { LoginPage } from '~/modules/login';

export default function BusinessLoginPage(): JSX.Element {
  return <LoginPage />;
}
